import { useEffect, useState } from 'react';

import { enqueueSnackbar } from 'notistack';
import { db } from 'src/utils/firebase'; // Adjust the import path based on your file structure

function useAchievements(userId) {
  const [achievements, setAchievements] = useState([]);
  const [isInitialLoad, setIsInitialLoad] = useState(true);

  useEffect(() => {
    if (!userId) {
      // setAchievements([]);
      // setIsInitialLoad(true); // Reset initial load state if userId changes or is null
      return () => {};
    }

    const unsubscribe = db
      .collection('users')
      .doc(userId)
      .collection('achievements')
      .onSnapshot((snapshot) => {
        console.log('achievements updated...');
        const fetchedAchievements = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        if (!isInitialLoad) {
          const newAchievements = fetchedAchievements.filter(
            (achievement) => !achievements.some((prev) => prev.id === achievement.id)
          );

          if (newAchievements.length > 0) {
            newAchievements.forEach((achievement) => {
              enqueueSnackbar(`New Achievement: ${achievement.title}`, {
                variant: 'success',
              });
            });
          }
        } else {
          setIsInitialLoad(false); // Disable initial load flag after the first load
        }

        setAchievements(fetchedAchievements);
      });

    return () => unsubscribe();
  }, [userId]);

  return achievements;
}

export default useAchievements;
